<template>
    <div>
        <div v-if="user == null">
            <button @click="signIn()">G Suiteアカウントでログイン</button>
        </div>
        <div v-else>
            <span>{{ user.displayName }} ({{ user.email }})</span>
            <button @click="signOut()">ログアウト</button>
            <hr>
            <app-main :user="user" />
        </div>
    </div>
</template>


<script>
import Firebase from 'firebase';
import Main from './Main.vue';

export default {
    data() {
        return {
            user: null,
        }
    },
    created() {
        Firebase.auth().onAuthStateChanged((user) => {
            this.user = user;
        })
    },
    methods: {
        signIn() {
            let provider = new Firebase.auth.GoogleAuthProvider();
            provider.setCustomParameters({
                hd: 'jjp.jp'
            })
            Firebase.auth().signInWithPopup(provider).then(function() {
            }).catch(function() {
            });
        },
        signOut() {
            Firebase.auth().signOut();
        }
    },
    components: {
        'app-main': Main,
    }
}
</script>


<style lang="scss">
html {
    font-family: sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue